import base from './base';

export default {
  ...base,
  name: 'beta',
  herbieApiHost: 'https://api-beta.cobli.co/herbie-1.1',
  apiHost: 'https://api-beta.cobli.co',
  apiV2: 'https://api-beta.cobli.co/v2',
  experience: 'https://api-beta.cobli.co/public',
  sentryDsn: 'https://3fcf796cfdb34accb2a13adf94086efd@sentry.io/469662',
  segmentAnalyticsKey: 'HT9TQZ1JlTTcioOFuqui3EPgDeYj0v9Y',
  googleMapsKey: 'AIzaSyB3fiz6lRgdLEMNGbpJ_LaRhP4LheDZyK0',
  cobliInviteUrl: 'https://cadastro-beta.cobli.co/invites',
  graphqlHost: 'https://api-beta.cobli.co/graphql',
  cerberusHost: 'https://api-beta.cobli.co/api-keys',
  oneSignalAppId: 'f8ecc101-ff24-48ee-a082-70c943ebe03a',
  ddRUMapplicationId: '60cdf473-9458-40a8-9dea-b7afa2780fef',
  ddRUMclientToken: 'pub29a278593a96327964c248285a4d7737',
  launchDarklyId: '5b5754656c774e2ec9e8f027',
  clarityId: '',
  geofenceApiHost: 'https://api.cobli.co/v3/geofences',
  alertsApiHost: 'https://api.cobli.co/v1/triggers',

  googleMapsVectorKey: 'AIzaSyDuhwkeLD1NXIgH2GJGNpKh1AYSt_r16VU',
};
